import React from 'react';

const Shift = () => {
    return (
      <React.Fragment>
        <div className="btn__base r6c3">
          <div className="btn">
            <div className="shift">Shift</div>
          </div>
        </div>
      </React.Fragment>
    );
  };

export default Shift;